import interceptorAxios from './InterceptorAxios';
import servicioObjetos from './ServicioObjetos';
const ServicioArchivos = {

    descargaArchivo(url, datos, objeto) {
        let request = {
            method: 'post',
            url: url,
            data: datos,
            responseType: 'arraybuffer'
        }
        interceptorAxios(request).then((response) => {
            let headers = response.headers;
            if (headers.mensaje)
                objeto.growl.show({ severity: 'error', summary: 'Error', detail: headers.mensaje,life:5000 });
            let encabezadoContent = headers['content-disposition'];
            let result = encabezadoContent.split(';')[1].trim().split('=')[1];
            let fileName = result.replace(/"/g, '');
            let a = document.createElement("a");
            let contentType = headers['content-type'];
            let tipo = this.elegirTipo(contentType);
            document.body.appendChild(a);
            let file = new Blob([response.data], {
                type: tipo
            });

           // var isChrome = !!window.chrome && !!window.chrome.webstore;
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            var isEdge = !isIE && !!window.StyleMedia;
            if (isEdge || isIE) {
                window.navigator.msSaveOrOpenBlob(file, fileName);
            }
            else {
                let fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = fileName;
                a.click();
            }

            /**
             * Se comenta este codido el 13 de marzo de 2021
             */
            // let fileURL = window.URL.createObjectURL(file);
            // a.href = fileURL;
            // a.download = fileName;
            // a.click();
        }).catch((error) => {
            console.log(error);
        });
    },

    elegirTipo(contentType) {
        let respuesta = "";
        switch (contentType) {
            case 'application/vnd.ms-excel':
                respuesta = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                break;

            case 'application/pdf':
                respuesta = contentType;
                break;

            case 'application/xml':
                respuesta = contentType;
                break;

            case 'application/zip':
                respuesta = contentType;
                break;

            case 'application/txt':
                respuesta = contentType;
                break;

            default:
                respuesta = "";
        }
        return respuesta;
    },
    obtenerBytesBase64StringArchivo(archivo, objeto, propiedad) {
        var reader = new FileReader();
        reader.readAsBinaryString(archivo);
        reader.onload = function () {
            var arrayBuffer = this.result;
            var base64Data = btoa(arrayBuffer);
            objeto[propiedad] = base64Data;
        };
    },
    descargaArchivoComoBlob(url, datos) {
        const request = {
            method: 'post',
            url: url,
            data: datos,
            responseType: 'arraybuffer'
        }
        return new Promise((resolve, reject) => {
            interceptorAxios(request).then((response) => {
                if (response.status !== 200) {
                    let mensaje = "Error de comunicación ";
                    reject(mensaje);
                }
                else {
                    let headers = response.headers;
                    let contentType = headers['content-type'];
                    if (servicioObjetos.esObjetoVacio(contentType))
                        reject("Existe un error al descargar el documento");
                    if (contentType.includes('application/json'))
                        reject(headers['mensaje']);
                    let encabezadoContent = headers['content-disposition'];
                    let result = encabezadoContent.split(';')[1].trim().split('=')[1];
                    let fileName = result.replace(/"/g, '');
                    let a = document.createElement("a");

                    let tipo = this.elegirTipo(contentType);
                    document.body.appendChild(a);
                    let file = new Blob([response.data], {
                        type: tipo
                    });
                    let fileURL = window.URL.createObjectURL(file);
                    a.href = fileURL;
                    a.download = fileName;
                    //a.click();
                    resolve(file);
                }
            }).catch((error) => {
                console.log("error: ", error);
                reject("Existe un error al descargar el documento");
            });
        });

    },

    obtenerBytesBase64StringArchivoPromise(archivo, objeto, propiedad) {
        return new Promise(function (resolve, reject) {
            // var reader = new FileReader();
            // reader.readAsBinaryString(archivo);
            // reader.onload = function () {
            //     var arrayBuffer = this.result;
            //     var base64Data = btoa(arrayBuffer);
            //     console.log("base64Data: ",base64Data);
            //     objeto[propiedad] = base64Data;
            //     resolve(objeto);
            // };
            let reader = new FileReader();
            let fileByteArray = [];
            reader.readAsArrayBuffer(archivo);
            reader.onloadend = function (evt) {
                if (evt.target.readyState === FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }
                    var base64Data = btoa(String.fromCharCode.apply(null, new Uint8Array(fileByteArray)));
                    objeto[propiedad] = base64Data;                    
                    resolve(objeto);
                }
            }
        });

    },

    base64ToArrayBuffer(base64) {
        var binaryString = window.atob(base64);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
           var ascii = binaryString.charCodeAt(i);
           bytes[i] = ascii;
        }
        return bytes;
     },
      guardarByteArray(reportName, byte) {
        var blob = new Blob([byte], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var fileName = reportName;
        link.download = fileName;
        link.click();
    }

}

export default ServicioArchivos;